import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import properties from "../config/properties.js";
import { validateToken } from '../services/authService';
import Footer from "../components/Footer";

const LoginMenu = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Estado para controlar el loader

  // Maneja el inicio de sesión con el proveedor (Google, Facebook, etc.)
  const handleLogin = (provider) => {
    const apiUrl = properties.oauth[provider].apiUrl;
    window.location.href = apiUrl; // Redirige a la URL de autenticación del proveedor
  };

  // Verifica la sesión del usuario al cargar el componente
  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const storedUser = sessionStorage.getItem("user");

        // Si hay un usuario en sessionStorage, redirige al home
        if (storedUser) {
          setUser(JSON.parse(storedUser));
          navigate("/", { replace: true }); // Redirige al home sin guardar en el historial
          return;
        }

        // Si no hay usuario en sessionStorage, valida el token
        const userData = await validateToken();

        if (userData) {
          setUser(userData); // Establece el usuario actual
          sessionStorage.setItem("user", JSON.stringify(userData)); // Guarda el usuario en sessionStorage
          navigate("/", { replace: true }); // Redirige al home sin guardar en el historial
        }
      } catch (error) {
        console.error("Error al validar la sesión:", error);

        // Si hay un error, limpia sessionStorage y recarga la página de login
        sessionStorage.removeItem("user");
        window.location.reload(); // Recarga la página para forzar un nuevo login
      } finally {
        setLoading(false); // Detiene el loader
      }
    };

    checkUserSession();
  }, [navigate]);

  // Muestra el loader mientras se verifica la sesión
  if (loading) {
    return <p>Cargando...</p>; // Puedes reemplazar esto con un componente Loader
  }

  return (
    <div className="main-container">
      <header className="azheader border-bottom">
        <div className="p-2">
          <div className="fs-3 text-left fw-1" style={{ margin: "0px auto" }}>
            <a href="/" style={{ textDecoration: "none" }}>
              <img
                src="img/favicon.png"
                style={{ verticalAlign: "bottom", marginRight: "10px" }}
                alt="LOGO"
              />
              <span className="fs-3"></span>
            </a>
          </div>
        </div>
      </header>
      <nav className="pt-2 px-4 border-bottom" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active" aria-current="page">Login</li>
        </ol>
      </nav>
      <main className="mt-0 p-2 fs-6 text-justify text-body-secondary" style={{ minHeight: '280px' }}>
        <div className="mt-3 text-center">
          <h2>Login using</h2>
          <div className="d-flex justify-content-center">
            <div
              className="card m-2 login-cards"
              style={{ width: "10rem" }}
              onClick={() => handleLogin("google")}
            >
              <div className="card-body text-center">
                <i className="bi bi-google fs-1"></i>
                <p className="card-text">Google</p>
              </div>
            </div>
            <div
              className="card m-2 login-cards"
              style={{ width: "10rem" }}
              onClick={() => handleLogin("facebook")}
            >
              <div className="card-body text-center">
                <i className="bi bi-facebook fs-1"></i>
                <p className="card-text">Facebook</p>
              </div>
            </div>
            <div
              className="card m-2 login-cards"
              style={{ width: "10rem" }}
              onClick={() => handleLogin("x")}
            >
              <div className="card-body text-center">
                <i className="bi bi-twitter fs-1"></i>
                <p className="card-text">X</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer /> {/* Siempre visible */}
    </div>
  );
};

export default LoginMenu;